import moment from 'moment';

// @vue/component
export default {
  name: 'ShTimeCounter',

  props: {
    isRunning: {
      type: Boolean,
      default: true,
    },
    connectionStartTime: {
      type: String,
      required: true,
      default: '16:20:00',
    },
  },
  data() {
    return {
      timeCounter: 0,
      timer: 0,
      stopedTime: 0,
    };
  },
  computed: {
    parseToTimestamp() {
      return moment.utc(this.timeCounter * 1000).format('HH:mm:ss');
    },
    parseToTimestampStoppedTime() {
      return moment.utc(this.stopedTime * 1000).format('HH:mm:ss');
    },
  },
  watch: {
    isRunning(newVal) {
      if (newVal === false) {
        this.stopedTime = this.timeCounter;
      }
    },
  },
  created() {
    this.getStartedTime();
  },
  beforeDestroy() {
    this.stopCounting();
  },
  methods: {
    getStartedTime() {
      let nowTimestamp = moment.utc(moment().format(), 'DD-MM-YYYY H:mm:ss');
      let startedConnectionTimestamp = moment.utc(this.connectionStartTime, 'DD-MM-YYYY H:mm:ss');
      this.timeCounter = nowTimestamp.diff(startedConnectionTimestamp, 'seconds');
      this.timer = setTimeout(this.startCounting, 1000);
    },
    startCounting() {
      this.timeCounter += 1;
      this.timer = setTimeout(this.startCounting, 1000);
    },
    stopCounting() {
      clearTimeout(this.timer);
      this.timer = 0;
      this.stopedTime = 0;
    },
  },
};
